// Lib
import React, { ReactElement, ReactNode, useCallback } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { selectIsMobileAppMode } from '../../../../../../platform/platformSelector';

// Components
import Icon from '../../../../../../components/icons/Icon';
import ShortcutKeyGroup from '../../../../../shortcuts/ShortcutKeyGroup';

// Styles
import './TextStyleEntry.scss';

export type TextStyleEntryBlockClassnames =
    | 'header-one'
    | 'header-two'
    | 'small-text'
    | 'code-block'
    | 'blockquote'
    | 'callout';

const TextStyleEntryShortcutKeyGroup = (props: { shortcut: string[] }) => {
    const { shortcut } = props;

    const isMobileApp = useSelector(selectIsMobileAppMode);

    if (isMobileApp) return null;

    return <ShortcutKeyGroup shortcut={shortcut} preferSymbol compact={false} />;
};

type TextStyleEntryProps = {
    active?: boolean;
    blockClassname?: TextStyleEntryBlockClassnames;
    shortcut: string[];
    onTextStyleSelect: () => void;
    children: ReactNode;
};

const TextStyleEntry = (props: TextStyleEntryProps): ReactElement => {
    const { active, blockClassname, shortcut, onTextStyleSelect, children } = props;

    const onClick = useCallback((event: React.MouseEvent) => {
        event.preventDefault();
        onTextStyleSelect();
    }, []);

    return (
        <div className={classNames('TextStyleEntry', { active })} onClick={!active ? onClick : undefined}>
            <div className={`block-style-text ${blockClassname}`}>{children}</div>
            {active ? <Icon name="block-style-tick" /> : <TextStyleEntryShortcutKeyGroup shortcut={shortcut} />}
        </div>
    );
};

export default TextStyleEntry;
